import { ComponentType } from 'react';
import { AdminShellIcons } from "../../Icons/AdminShellIcons";

export type AdminTab =
  | 'orders'
  | 'courses'
  | 'programs'
  | 'bookings'
  | 'groups'
  | 'newsletter'
  | 'campaigns'
  | 'tools'
  | 'seminars';

export const ADMIN_TABS: {
  id: AdminTab;
  label: string;
  path: string;
  icon: ComponentType<{ size?: number; className?: string }>;
}[] = [

  { id: 'orders', label: 'Ordrar', path: '/admin/orders', icon: AdminShellIcons.Orders },
  { id: 'courses', label: 'Kurser', path: '/admin/courses', icon: AdminShellIcons.Courses },
  { id: 'programs', label: 'Program', path: '/admin/programs', icon: AdminShellIcons.Programs },
  { id: 'bookings', label: 'Bokningar', path: '/admin/bookings', icon: AdminShellIcons.Bookings },
  { id: 'groups', label: 'Grupper', path: '/admin/groups', icon: AdminShellIcons.Groups },
  { id: 'newsletter', label: 'Nyhetsbrev', path: '/admin/newsmail', icon: AdminShellIcons.News },
  { id: 'campaigns', label: 'Kampanjer', path: '/admin/promo-code', icon: AdminShellIcons.Campains },
  { id: 'tools', label: 'Verktyg', path: '/admin/tools', icon: AdminShellIcons.Tools },
  { id: 'seminars', label: 'Seminarier', path: '/admin/seminars', icon: AdminShellIcons.Seminars }
];

export const getActiveAdminTab = (path: string): AdminTab => {
  if (path.startsWith('/admin/orders')) return 'orders';
  if (path.startsWith('/admin/courses')) return 'courses';
  if (path.startsWith('/admin/programs')) return 'programs';
  if (path.startsWith('/admin/bookings')) return 'bookings';
  if (path.startsWith('/admin/groups')) return 'groups';
  if (path.startsWith('/admin/newsmail')) return 'newsletter';
  if (path.startsWith('/admin/promo-code')) return 'campaigns';
  if (path.startsWith('/admin/tools')) return 'tools';
  if (path.startsWith('/admin/seminars')) return 'seminars';
  return 'courses';
};
